// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__xxZYg","full-width":"Table_full-width__2DtYD"};